(() => {
  const makeId = (heading, index) => {
    const existing = heading.id;
    if (existing) return existing;
    const text = heading.textContent.trim().toLowerCase();
    const slug = text
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
    heading.id = slug || `section-${index + 1}`;
    return heading.id;
  };

  document.querySelectorAll('[data-rd-article]').forEach((article) => {
    const content = article.querySelector('[data-rd-article-content]');
    const toc = article.querySelector('[data-rd-article-toc]');
    const list = article.querySelector('[data-rd-article-toc-list]');
    if (!content || !toc || !list) return;

    const headings = [...content.querySelectorAll('h2')];
    if (!headings.length) return;

    headings.forEach((heading, index) => {
      const id = makeId(heading, index);
      const link = document.createElement('a');
      link.href = `#${id}`;
      link.textContent = heading.textContent.trim();
      list.append(link);
    });

    toc.hidden = false;
    const links = [...list.querySelectorAll('a')];
    const setCurrent = (id) => links.forEach((link) => link.classList.toggle('is-active', link.hash === `#${id}`));
    const observer = new IntersectionObserver(
      (entries) => {
        const current = entries.filter((entry) => entry.isIntersecting).sort((a, b) => a.boundingClientRect.top - b.boundingClientRect.top)[0];
        if (current) setCurrent(current.target.id);
      },
      { rootMargin: '-18% 0px -68% 0px', threshold: 0 }
    );
    headings.forEach((heading) => observer.observe(heading));
  });
})();
